import css from './styles.module.css';

export function MetricSkeleton() {
  return <div className={css.skeleton} />;
}
